import React, {useEffect, useMemo} from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Navigation from "../../components/PicksforPartners/navigation"
import Top from "../../components/PicksforPartners/top"
import WhyPicks from "../../components/PicksforPartners/why-picks"
import HowToUsePicks from "../../components/PicksforPartners/how-to-use-picks"
import FlowIntroduction from "../../components/PicksforPartners/flow-introduction"
import CaseIntroduction from "../../components/PicksforPartners/case-introduction"
import FrequentlyAskedQuestion from "../../components/PicksforPartners/frequently-asked-question"
import Footers from "../../components/PicksforPartners/footers"
import TagManager from 'react-gtm-module';

const PicksforPartnersPage = () => {

  useEffect(()=> {
    TagManager.initialize({ gtmId: 'GTM-W938GKG' });
  })

  useEffect(() => {
    window.location = "https://start.picks.fun/"
  }, [])

  return (
    <></>
  )

  return (
    <Layout>
      <SEO bodyClassName="has-navbar-fixed-top" />
      <div className="picksfor-partners">
        <Navigation />
        <section className="hero is-fullheight-with-navbar">
          <div className="hero-body pa-0">
            <Top />
          </div>
        </section>
        <section id="why-picks">
          <WhyPicks />
        </section>
        <section id="how-to-use-picks">
          <HowToUsePicks />
        </section>
        <section id="flow-introduction">
          <FlowIntroduction />
        </section>
        <section id="case-introduction">
          <CaseIntroduction />
        </section>
        <section id="frequently-asked-question">
          <FrequentlyAskedQuestion />
        </section>
        <section>
          <Footers />
        </section>
      </div>
    </Layout>
  )
}

export default PicksforPartnersPage
